import React, { useMemo } from 'react';
import { Box } from '@tanium/react-box';
import { Icon } from '@tanium/react-graphics';
import { Stack } from '@tanium/react-stack';
import { useTheme } from '@tanium/react-theme-context';
import { ColorStyleProps } from '@tanium/style-system';
import { BackgroundFill, Border, IconFill, MessageText } from './themeDefinitions';

export interface Props extends Pick<ColorStyleProps, 'bg' | 'backgroundColor'> {
  className?: string;
  icon?: Icon;
  children?: React.ReactNode;
}

export const EmptyState = ({
  bg = BackgroundFill,
  backgroundColor = bg,
  className,
  children,
  icon: IconComponent,
}: Props) => {
  const theme = useTheme();
  const iconColor = IconFill(theme);
  const iconStyle = useMemo(() => ({ display: 'block', color: iconColor }), [iconColor]);

  return (
    <Stack
      p={3}
      backgroundColor={backgroundColor}
      border={1}
      borderColor={Border}
      textAlign="center"
      fontWeight="bold"
      direction="column"
      alignItems="center"
      itemSpacing={3}
      justifyContent="center"
      className={className}
    >
      {IconComponent && (
        <IconComponent height={48} width={48} style={iconStyle} role="presentation" />
      )}
      <Box color={MessageText}>{children}</Box>
    </Stack>
  );
};
